"use strict";
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NrpsMemberStatus = exports.NrpsMemberRoleLong = exports.NrpsMemberRole = exports.LtiVersion = exports.LtiPlacement = exports.LtiLaunchContainer = exports.H5PLaunchType = exports.GradingProgress = exports.ActivityProgress = void 0;
var ActivityProgress;
(function (ActivityProgress) {
    ActivityProgress["INITIALIZED"] = "Initialized";
    ActivityProgress["STARTED"] = "Started";
    ActivityProgress["IN_PROGRESS"] = "InProgress";
    ActivityProgress["SUBMITTED"] = "Submitted";
    ActivityProgress["COMPLETED"] = "Completed";
})(ActivityProgress = exports.ActivityProgress || (exports.ActivityProgress = {}));
var GradingProgress;
(function (GradingProgress) {
    GradingProgress["NOT_READY"] = "NotReady";
    GradingProgress["FAILED"] = "Failed";
    GradingProgress["PENDING"] = "Pending";
    GradingProgress["PENDING_MANUAL"] = "PendingManual";
    GradingProgress["FULLY_GRADED"] = "FullyGraded";
})(GradingProgress = exports.GradingProgress || (exports.GradingProgress = {}));
var H5PLaunchType;
(function (H5PLaunchType) {
    H5PLaunchType["CONTENT_SELECTION"] = "content-selection";
    H5PLaunchType["BASIC"] = "basic";
})(H5PLaunchType = exports.H5PLaunchType || (exports.H5PLaunchType = {}));
var LtiLaunchContainer;
(function (LtiLaunchContainer) {
    LtiLaunchContainer["WINDOW"] = "window";
    LtiLaunchContainer["IFRAME"] = "iframe";
})(LtiLaunchContainer = exports.LtiLaunchContainer || (exports.LtiLaunchContainer = {}));
var LtiPlacement;
(function (LtiPlacement) {
    LtiPlacement["MATERIALS"] = "materials";
    LtiPlacement["ASSIGNMENTS"] = "assignments";
})(LtiPlacement = exports.LtiPlacement || (exports.LtiPlacement = {}));
var LtiVersion;
(function (LtiVersion) {
    LtiVersion["ONE_POINT_ONE"] = "1.1";
    LtiVersion["ONE_POINT_THREE"] = "1.3";
})(LtiVersion = exports.LtiVersion || (exports.LtiVersion = {}));
var NrpsMemberRole;
(function (NrpsMemberRole) {
    NrpsMemberRole["INSTRUCTOR"] = "Instructor";
    NrpsMemberRole["LEARNER"] = "Learner";
})(NrpsMemberRole = exports.NrpsMemberRole || (exports.NrpsMemberRole = {}));
var NrpsMemberRoleLong;
(function (NrpsMemberRoleLong) {
    NrpsMemberRoleLong["INSTRUCTOR"] = "http://purl.imsglobal.org/vocab/lis/v2/membership#Instructor";
    NrpsMemberRoleLong["LEARNER"] = "http://purl.imsglobal.org/vocab/lis/v2/membership#Learner";
})(NrpsMemberRoleLong = exports.NrpsMemberRoleLong || (exports.NrpsMemberRoleLong = {}));
var NrpsMemberStatus;
(function (NrpsMemberStatus) {
    NrpsMemberStatus["ACTIVE"] = "Active";
    NrpsMemberStatus["INACTIVE"] = "Inactive";
})(NrpsMemberStatus = exports.NrpsMemberStatus || (exports.NrpsMemberStatus = {}));
